import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgSparkle = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.3785 14.3285L12.2035 20.3097C12.1502 20.4532 12.0543 20.577 11.9286 20.6644C11.8029 20.7519 11.6535 20.7987 11.5004 20.7987C11.3472 20.7987 11.1978 20.7519 11.0721 20.6644C10.9464 20.577 10.8505 20.4532 10.7972 20.3097L8.62223 14.3285C8.58424 14.2254 8.52433 14.1317 8.44664 14.054C8.36895 13.9764 8.27532 13.9164 8.17223 13.8785L2.19098 11.7035C2.04744 11.6502 1.92365 11.5543 1.83624 11.4286C1.74882 11.3029 1.70197 11.1534 1.70197 11.0003C1.70197 10.8472 1.74882 10.6978 1.83624 10.5721C1.92365 10.4464 2.04744 10.3505 2.19098 10.2972L8.17223 8.12221C8.27532 8.08422 8.36895 8.02432 8.44664 7.94663C8.52433 7.86893 8.58424 7.77531 8.62223 7.67221L10.7972 1.69096C10.8505 1.54743 10.9464 1.42364 11.0721 1.33622C11.1978 1.24881 11.3472 1.20195 11.5004 1.20195C11.6535 1.20195 11.8029 1.24881 11.9286 1.33622C12.0543 1.42364 12.1502 1.54743 12.2035 1.69096L14.3785 7.67221C14.4165 7.77531 14.4764 7.86893 14.5541 7.94663C14.6318 8.02432 14.7254 8.08422 14.8285 8.12221L20.8097 10.2972C20.9533 10.3505 21.077 10.4464 21.1645 10.5721C21.2519 10.6978 21.2987 10.8472 21.2987 11.0003C21.2987 11.1534 21.2519 11.3029 21.1645 11.4286C21.077 11.5543 20.9533 11.6502 20.8097 11.7035L14.8285 13.8785C14.7254 13.9164 14.6318 13.9764 14.5541 14.054C14.4764 14.1317 14.4165 14.2254 14.3785 14.3285V14.3285Z"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgSparkle.displayName = 'SvgSparkle';
export default SvgSparkle;
